/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

import validators from './validators';

export default validators;
